<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
			<!-- Empty car-->
				<section class="account-section">
					<h2>Mi cuenta</h2>
					<h3>Bienvenido a Lasddi</h3><br>
					<p v-if="!render_purchase_orders.length" class="empty">No hay pedidos en curso</p>
					<p class="account-text" v-if="render_purchase_orders.length">Pedidos en curso ({{ render_purchase_orders.length }})</p>
					<div class="table-responsive">
						<table class="table" v-if="render_purchase_orders.length">
							<thead>
								<tr>
									<th>Id</th>
									<th>Fecha</th>
									<th>No. de pedido</th>
									<th>Archivo</th>
									<th>Total</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="order in render_purchase_orders">
									<td>{{ $index + 1 }}</td>
									<td>{{ moment(order.created_at).format('YYYY-MM-DD') }}</td>
									<td>{{ order.payment_id }}</td>
									<td><a href="{{ link }}/users/me/purchaseOrders/{{ order.payment_id }}/pdf?api_token={{ render_user.token }}" target="_blank">Descargar</a></td>
									<td>${{ accounting.formatMoney(parseFloat(order.total).toFixed(2), '') }}</td>
									<td class="text-uppercase">{{ order.status_string }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<style scoped>
	h3 {
		font-family: "Montserrat";
	}
</style>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import default_image from '../../images/default.jpg';
import { api_base } from '../../store/api';
import moment from 'moment';
import accounting from '../../scripts/accounting';

export default {
	data() {
		return {
			image: default_image,
			link: api_base,
			accounting
		}
	},

	// ---- VUEX ----
	
	vuex: {
		getters: {
			user: state => state.current_user,
			orders: state => {
				let orders = state.purchase_orders;
				let purchase_orders = [];

				for (let i = 0, o = orders; i < o.length; i++) {
					if (o[i].status_string.toLowerCase() != 'pagado')
						purchase_orders.push(o[i]);
				}

				return purchase_orders;
			},
			products: state => {
				// getters are awesome.
				let orders = state.purchase_orders;
				var products = [];
				// iterate in orders and in the products that are in the orders.
				for (let i = 0; i < orders.length; i++) {
					for (let j = 0; j < orders[i].products.length; j++) {
						// save the products to show it.
						products.push(orders[i].products[j]);
					}
				}
				// get the product images.
				for (let i = 0; i < state.products.length; i++) {
					for (let j = 0; j < products.length; j++) {
						if (state.products[i].id == products[j].product.id) {
							products[j].product.images = state.products[i].images;
						}
					}
				}
				// return the products.
				return products;
			}
		}
	},

	// ---- RENDER ----

	computed: {
		render_purchase_orders() {
			return this.orders;
		},

		render_user () {
			return this.user;
		}
	},

	methods: {
		getMainImage (product) {
			if (product.images.length) {
				return product.images[0].route;
			}

			return this.image;
		},

		moment
	},
	
	// ---- COMPONENTS ----

  components: {
  	Breadcrumb,
  	Sidebar,
  },
};
</script>


// WEBPACK FOOTER //
// Welcome.vue?34a03e1a